var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMapMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.015 16.868c0-8.217 6.557-14.853 14.613-14.853S31.24 8.651 31.24 16.868c0 1.929-.874 4.327-2.314 6.924-1.426 2.571-3.34 5.221-5.273 7.624-1.93 2.4-3.864 4.531-5.316 6.064-.702.74-1.29 1.34-1.71 1.762a98.535 98.535 0 01-1.708-1.762 101.913 101.913 0 01-5.316-6.063c-1.934-2.404-3.848-5.054-5.273-7.625-1.44-2.597-2.315-4.995-2.315-6.924zM15.93 41.385l.699-.726.699.726-.7.672-.698-.672zm0 0l.699-.726.699.726.013-.013.035-.034a44.042 44.042 0 00.637-.63 99.71 99.71 0 001.788-1.842 103.907 103.907 0 005.423-6.186c1.971-2.45 3.963-5.2 5.466-7.91 1.488-2.685 2.567-5.45 2.567-7.902C33.256 7.567 25.826 0 16.628 0S0 7.567 0 16.868c0 2.451 1.079 5.217 2.567 7.902 1.503 2.71 3.494 5.46 5.466 7.91a103.914 103.914 0 005.423 6.186 100.097 100.097 0 002.29 2.341l.135.131.035.034.013.013zm.699-32.974a8.217 8.217 0 100 16.434 8.217 8.217 0 000-16.434zm-6.202 8.217a6.201 6.201 0 1112.403 0 6.201 6.201 0 01-12.403 0z",
    fill: "#64A70B"
  })));
}

export default SvgMapMarker;